var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': `${_vm.paddingTop}px`,
    'padding-bottom': `${_vm.paddingBottom}px`
  })},[_c('div',{staticClass:"certificates",on:{"click":function($event){return _vm.$emit('chooseImage')}}},[_c('ui-image',{attrs:{"file-data":_vm.mainFields?.image?.value ? { fileId: _vm.mainFields?.image?.value } : {},"loading":"eager"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }